import { useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { toDonationBudgetFilterSearch, toDonationBudgetFilterValues } from '../utils/mpFilters';

const route = getRouteApi('/_auth/market-promotion/budget-entry');

const normalizeFilterValues = (values: Record<string, string>) =>
  toDonationBudgetFilterValues(toDonationBudgetFilterSearch(values));

export function useDonationBudgetFilters() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const appliedValues = useMemo(() => toDonationBudgetFilterValues(search), [search]);

  const filters = useUrlSyncedFilters({
    appliedValues,
    normalizeValues: normalizeFilterValues,
    onApply: (values) => {
      void navigate({
        search: (previous) => ({ ...previous, ...toDonationBudgetFilterSearch(values) }),
        replace: true,
      });
    },
  });

  return { ...filters, search };
}
